import apiRoutes from "../../utils/constants/apiRoutes";
import ApiService from "../apiService";
import handleApiCall from "../handleApi";

export const getModuleService = async () =>
  handleApiCall(() => ApiService.get(apiRoutes.module));

export const getModuleByIdService = async (id: string) =>
  handleApiCall(() => ApiService.get(apiRoutes.moduleById.replace(":id", id)));
